const PULL_QUOTES_STORAGE_KEY = 'dragonfly:dog-profile:v1';
const PULL_QUOTES_EVENT = 'dragonfly:dog-profile-change';
const PULL_QUOTES_NO_BREED = new Set(['mixed breed', "don't know", 'dont know', 'prefer not to say']);

function readPullQuoteProfile() {
  if (typeof window.DragonflyDogProfile?.read === 'function') {
    return window.DragonflyDogProfile.read();
  }

  try {
    const raw = window.localStorage.getItem(PULL_QUOTES_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed) return null;
    return {
      size: typeof parsed.size === 'string' ? parsed.size.trim() : '',
      age: typeof parsed.age === 'string' ? parsed.age.trim() : '',
      breed: typeof parsed.breed === 'string' ? parsed.breed.trim() : '',
    };
  } catch (error) {
    return null;
  }
}

function pickerBreed(profile) {
  const breed = String(profile?.breed || '').trim();
  if (!breed || PULL_QUOTES_NO_BREED.has(breed.toLowerCase())) return '';
  return breed;
}

function quoteBreed(item) {
  return String(item.dataset.breed || '').trim();
}

function quoteSizeId(item) {
  return String(item.dataset.sizeId || '').trim().toLowerCase();
}

function quoteAgeId(item) {
  return String(item.dataset.ageId || '').trim().toLowerCase();
}

function breedsMatch(left, right) {
  return left.toLowerCase() === right.toLowerCase();
}

function pickPullQuotes(items, profile, limit) {
  if (!items.length) return [];

  const cap = Math.max(1, limit);
  const breed = pickerBreed(profile);
  const sizeId = String(profile?.size || '').trim().toLowerCase();
  const ageId = String(profile?.age || '').trim().toLowerCase();

  if (!profile || (!breed && !sizeId && !ageId)) {
    const preferred = items.filter((item) => quoteBreed(item) || quoteSizeId(item));
    return (preferred.length ? preferred : items).slice(0, cap);
  }

  const scored = items.map((item, index) => {
    const itemBreed = quoteBreed(item);
    const itemSize = quoteSizeId(item);
    const itemAge = quoteAgeId(item);
    const breedHit = Boolean(breed && itemBreed && breedsMatch(itemBreed, breed));
    const sizeHit = Boolean(sizeId && itemSize && itemSize === sizeId);
    const ageHit = Boolean(ageId && itemAge && itemAge === ageId);
    let score = 0;
    if (breedHit) score += 100;
    if (sizeHit) score += 50;
    if (ageHit) score += 10;
    return { item, index, breedHit, sizeHit, score };
  });

  let pool = [];
  if (breed) {
    pool = scored.filter((entry) => entry.breedHit);
  }
  if (!pool.length && sizeId) {
    pool = scored.filter((entry) => entry.sizeHit);
  }
  if (!pool.length) {
    pool = scored;
  }

  return pool
    .sort((a, b) => b.score - a.score || a.index - b.index)
    .slice(0, cap)
    .map((entry) => entry.item);
}

if (!customElements.get('pull-quotes')) {
  customElements.define(
    'pull-quotes',
    class PullQuotes extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('[data-pull-quote]'));
        this.limit = Number(this.dataset.limit || 1) || 1;
        this.onProfileChange = () => this.applyMatch();
        window.addEventListener(PULL_QUOTES_EVENT, this.onProfileChange);
        this.applyMatch();
      }

      disconnectedCallback() {
        window.removeEventListener(PULL_QUOTES_EVENT, this.onProfileChange);
      }

      applyMatch() {
        const selected = pickPullQuotes(this.items, readPullQuoteProfile(), this.limit);
        this.items.forEach((item) => {
          item.hidden = !selected.includes(item);
        });
      }
    }
  );
}
